import UserSessionDataHandler from 'auth/UserSessionsDataHandler';

export const getUserUidFromStorage = () =>
  UserSessionDataHandler.getUserDataObject().uid;

export const getDashboardConfig = () =>
  UserSessionDataHandler.getDashboardConfig();
